import { CharacterType, CharacterCase } from '../../types/enums';

const CharacterSections = {
  PRINT: {
    characterType: CharacterType.PRINT,
    characterCase: CharacterCase.UPPERCASE,
  },
  print: {
    characterType: CharacterType.PRINT,
    characterCase: CharacterCase.LOWERCASE,
  },
  CURSIVE: {
    characterType: CharacterType.CURSIVE,
    characterCase: CharacterCase.UPPERCASE,
  },
  cursive: {
    characterType: CharacterType.CURSIVE,
    characterCase: CharacterCase.LOWERCASE,
  },
  123: {
    characterType: CharacterType.NUMBER,
  },
};

export default CharacterSections;
